// Set these in frontend/.env (never commit secrets). See .env.example.
// Production uses the PHP handler in public/api (same origin). Override with REACT_APP_API_URL to use another backend.
export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === "production" ? "/api" : "");
export const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || ""; // Calendly / Cal.com / Google Calendar link
export const WHATSAPP = process.env.REACT_APP_WHATSAPP || ""; // digits only, e.g. 919999999999
export const CONTACT_EMAIL = "yash@alphabetgreens.in"; // from Gold Standard Marketplace listing; consider a shared inbox
export const COMPANY = {
  name: "Alphabet Greens Private Limited",
  address: "G-16, Apollo Industrial Estate, Off Mahakali Caves Road, Andheri (East), Chakala MIDC, Mumbai, Maharashtra 400093, India",
  cin: "U94110MH2023PTC398387",
};
